import { PickupZone } from "@/types/api/api-types";
import { Button } from "@/components/ui/button";
import { Pen } from "lucide-react";

type CollectionZoneElemProps = {
  zone: PickupZone;
  handleEdit: (zone: PickupZone | null) => void;
};

export const CollectionZoneElem = ({ zone, handleEdit }: CollectionZoneElemProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex flex-1 flex-row gap-4">
        <div
          className={`h-[23px] w-[23px] rounded-[4px] border border-gray-200`}
          style={{ backgroundColor: zone.color }}
        />
        <p className="text-sm font-medium text-gray-900">{zone.name}</p>
      </div>
      <Button variant="outline" className="flex flex-row gap-4" onClick={() => handleEdit(zone)}>
        <Pen className="text-gray-600" />
      </Button>
    </div>
  );
};
